module.exports = __webpack_public_path__ + "returnSample.2e889dbf0b6e16a8dff12602175447fc.png";